import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function orderList(state = initialState.transactions, action) {
    switch (action.type) {
        case types.LOAD_TRANSACTION_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                params: action.params
            })
        case types.LOAD_TRANSACTION_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                errorMessage: '',
                data: action.data
            })
        case types.LOAD_TRANSACTION_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                errorMessage: {
                    ...action.messages
                }
            })

        case types.LOAD_MORE_TRANSACTION_REQUEST:
            return Object.assign({}, state, {
                isFetchingMore: true
            })
        case types.LOAD_MORE_TRANSACTION_SUCCESS:
            return Object.assign({}, state, {
                isFetchingMore: false,
                errorMessage: '',
                data: {
                    ...state.data,
                    ...action.data,
                    results: [
                        ...state.data.results,
                        ...action.data.results
                    ]
                }
            })
        case types.LOAD_MORE_TRANSACTION_FAILURE:
            return Object.assign({}, state, {
                isFetchingMore: false,
                errorMessage: {
                    ...action.messages
                }
            })

        case types.RESET_ALL_INFO:
            return initialState.transactions

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/transactionReducer.js